import { render, staticRenderFns } from "./SignupCard.vue?vue&type=template&id=2985e678&"
import script from "./SignupCard.vue?vue&type=script&lang=js&"
export * from "./SignupCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2985e678')) {
      api.createRecord('2985e678', component.options)
    } else {
      api.reload('2985e678', component.options)
    }
    module.hot.accept("./SignupCard.vue?vue&type=template&id=2985e678&", function () {
      api.rerender('2985e678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cards/SignupCard.vue"
export default component.exports